import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Categories from "@/components/site/Categories";
import ProductsGallery from "@/components/site/ProductsGallery";
import Sustainability from "@/components/site/Sustainability";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import SmoothScroll from "@/components/site/SmoothScroll";
import WhatsAppQuote from "@/components/site/WhatsAppQuote";
import { LangProvider, useLang } from "@/lib/LangContext";
import { initAnalytics } from "@/lib/analytics";

function Home() {
  const { isRTL } = useLang();
  useEffect(() => {
    initAnalytics();
  }, []);
  return (
    <div className="App grain relative" data-rtl={isRTL ? "true" : "false"}>
      <SmoothScroll />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <ProductsGallery />
        <Categories />
        <Sustainability />
        <Contact />
      </main>
      <Footer />
      <WhatsAppQuote />
      <Toaster
        position={isRTL ? "bottom-left" : "bottom-right"}
        toastOptions={{
          style: {
            background: "#1A1918",
            color: "#F7F5F0",
            border: "1px solid rgba(247,245,240,0.15)",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
